import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FooterLinkComponent } from '../footer-link/footer-link.component';
import { FooterSocialLinksComponent } from '../footer-social-links/footer-social-links.component';

@Component({
  selector: 'app-footer-first-column',
  imports: [FooterLinkComponent, FooterSocialLinksComponent],
  templateUrl: './footer-first-column.component.html',
  styleUrl: './footer-first-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterFirstColumnComponent {}
